// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"4ee88e35","787":"13f97624"}[chunkId] + ".chunk.js";
};